import { render } from "./DocumentTagTypeList.vue?vue&type=template&id=e1eda3a0&scoped=true"
import script from "./DocumentTagTypeList.vue?vue&type=script&lang=js"
export * from "./DocumentTagTypeList.vue?vue&type=script&lang=js"

import "./DocumentTagTypeList.vue?vue&type=style&index=0&id=e1eda3a0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1eda3a0"]])

export default __exports__